import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import POCViewer from './components/POCViewer';
import { Toaster } from './components/ui/sonner';

// Main home page - redirects to POC for now
const Home = () => {
  return <Navigate to="/poc" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/poc" element={<POCViewer />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors closeButton />
    </div>
  );
}

export default App;
